import { Tab as TabMui, Tabs as TabsMui } from '@mui/material'
import _ from 'lodash'
import { generatePath, Navigate, useNavigate, useParams } from 'react-router-dom'

import Paper from 'components/Paper'
import Tooltip from 'components/Tooltip'
import { ROUTES } from 'routes'
import { Tab, TabsProps, TabsUrlParams } from './types'

export const Tabs = <T extends string>({
  path,
  productFruitsSelector,
  tabs,
}: TabsProps<T>): JSX.Element => {
  const navigate = useNavigate()
  const { id, tab: currentTab, workspaceId } = useParams<TabsUrlParams<T>>()

  if (
    !currentTab ||
    !_.includes(
      tabs.map((t: Tab<T>): T => t.element),
      currentTab,
    )
  ) {
    return <Navigate to={ROUTES.BASE.NOT_FOUND} />
  }

  const handleTabClick = (tab: Tab<T>): void => {
    navigate(
      generatePath(path, {
        id,
        tab: tab.element,
        workspaceId,
      }),
    )
  }

  return (
    <Paper
      spacing='m'
      sx={{ px: 3 }}
    >
      <TabsMui
        data-product-fruits={productFruitsSelector}
        value={currentTab}
      >
        {tabs.map((tab: Tab<T>): JSX.Element => {
          const key: Tab<T>['label'] = tab.label

          const TabComponent: JSX.Element = (
            <TabMui
              data-cy={tab.element}
              data-product-fruits={tab.productFruitsSelector}
              disabled={tab.disabled}
              key={key}
              label={tab.label}
              onClick={(): void => handleTabClick(tab)}
              value={tab.element}
            />
          )

          return tab.tooltip ? (
            <Tooltip
              key={key}
              {...tab.tooltip}
            >
              {TabComponent}
            </Tooltip>
          ) : (
            TabComponent
          )
        })}
      </TabsMui>
    </Paper>
  )
}
